import { render, staticRenderFns } from "./manage_sum.vue?vue&type=template&id=632606c4&scoped=true&"
import script from "./manage_sum.vue?vue&type=script&lang=js&"
export * from "./manage_sum.vue?vue&type=script&lang=js&"
import style0 from "./manage_sum.vue?vue&type=style&index=0&id=632606c4&scoped=true&lang=less&"
import style1 from "./manage_sum.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632606c4",
  null
  
)

export default component.exports